import React from "react";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { RoutePaths } from "src/app/model";

export const Logo: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Typography
      variant="h4"
      color="primary"
      onClick={() => {
        navigate(RoutePaths.HOME);
        window.scrollTo(0, 0);
      }}
      sx={{
        textShadow: "1px 1px 20px rgba(166,228,176,1);",
        order: { md: "initial", xs: "1" },
        flexGrow: { md: 0, xs: 1 },
        textAlign: { md: "start", xs: "center" },
        cursor: "pointer",
      }}
    >
      SB
    </Typography>
  );
};
